import { Helmet } from 'react-helmet-async';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Utensils } from "lucide-react";
import { Link } from "react-router-dom";
const SportsNutrition = () => {
  return <>
      <Helmet>
        <title>Sports Nutrition Services | Functional Foodie</title>
        <meta name="description" content="Professional sports nutrition services in Johannesburg. Optimize your athletic performance with tailored nutrition plans. Consult with Functional Foodie today." />
      </Helmet>
      <section id="sports-nutrition" className="py-16">
        <div className="container mx-auto px-4">
          <Card className="border-none shadow-lg hover:shadow-xl transition-shadow duration-300 bg-[#accfd7]/20">
            <CardHeader className="flex flex-row items-center gap-4">
              <div className="p-4 rounded-full bg-[#accfd7]/50">
                <Utensils className="w-8 h-8 text-[#6196a0]" />
              </div>
              <CardTitle className="text-xl font-semibold text-primary">
                Sports Nutrition
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="space-y-6">
                <p className="text-gray-600 leading-relaxed">
                  We will assist in fuelling your body prior to exercise and also in the recovery phase in order to enhance your performance. Allowing you to get the most out of training sessions.
                </p>
                
                <h3 className="text-lg font-semibold text-primary mt-8">Performance Optimisation</h3>
                <p className="text-gray-600 leading-relaxed">Our sports nutrition services are designed to help athletes of all levels optimise their performance through evidence-based nutrition strategies tailored to their specific sport and training regimen.</p>
                
                <h3 className="text-lg font-semibold text-primary">Our Approach</h3>
                <ul className="list-disc pl-6 space-y-2 text-gray-600">
                  <li>Sport-specific nutrition assessment</li>
                  <li>Pre-training and competition fueling strategies</li>
                  <li>Recovery nutrition protocols</li>
                  <li>Hydration strategies</li>
                  <li>Supplement evaluation and recommendations</li>
                  
                </ul>
                
                <h3 className="text-lg font-semibold text-primary">Who Can Benefit</h3>
                <p className="text-gray-600 leading-relaxed">Our sports nutrition services are ideal for recreational sports enthusiasts, and fitness enthusiasts looking to enhance their performance and recovery through optimal nutrition.</p>
                
                <div className="mt-8 flex justify-center">
                  <Link to="/booking">
                    <Button size="lg" className="bg-primary hover:bg-primary-light text-white px-8">
                      Book a Consultation
                    </Button>
                  </Link>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </section>
    </>;
};
export default SportsNutrition;